exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tori-web-agent-container {\n  position: fixed;\n  bottom: 1rem;\n  right: 1rem;\n  z-index: 1000;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/tori-web-agent/tori-web-agent.component.css
// module id = ../../../../../src/app/shared/components/tori-web-agent/tori-web-agent.component.css
// module chunks = main